module.exports = __webpack_public_path__ + "static/img/1.b7ac237.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/1.png
// module id = P8lh
// module chunks = 0